import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Lock } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-slate-950" data-id="element-55">
      {/* Green top accent line */}
      <div className="max-w-2xl mx-auto" data-id="element-56">
        <div className="w-full h-1 bg-green-500 rounded-full mb-12" data-id="element-57" />
      </div>

      <div className="max-w-2xl mx-auto" data-id="element-58">
        <FadeIn data-id="element-59">
          <div className="bg-slate-900 border border-slate-800 rounded-2xl p-8 md:p-12 text-center" data-id="element-60">
            <Lock className="w-10 h-10 text-amber-500 mx-auto mb-6" strokeWidth={2} data-id="element-61" />

            <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-62">
              🔒 GARANTÍA EN AMBAS OPCIONES
            </h2>

            <p className="text-xl text-white font-medium mb-8" data-id="element-63">
              7 días de garantía total. Devolución del 100% sin preguntas.
            </p>

            <p className="text-slate-400 leading-relaxed mb-8" data-id="element-64">
              Sea cual sea la opción que elijas — estás completamente protegido.
              Si por cualquier razón sentís que no es lo que prometemos,
              escribinos dentro de los 7 días posteriores a la compra y te
              devolvemos el dinero completo. Sin formularios. Sin preguntas. Sin
              demoras.
            </p>

            <p className="text-xl text-amber-500 font-bold italic" data-id="element-65">
              El riesgo es completamente nuestro. La mejora es completamente
              tuya.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}